<template>
    <div>
        <form class="form filters">
            <div class="row">
                <div class="col-12">
                    <div class="form__item">
                        <i class="form__icon icons icon-user"></i>
                        <input class="form__input--text" v-model="nameFilter" label="name" :class="{ 'has-value': !!nameFilter }" />
                        <label class="form__label">{{$t('forms.common.labels.name')}}</label>
                    </div>
                </div>
            </div>
        </form>
        <div class="table__responsive">
            <table class="table">
                <thead v-if="!loadingStudents  && evaluationStudents.length">
                    <tr>
                        <th>{{$t('evaluations.first_name')}}</th>
                        <th>{{$t('evaluations.last_name')}}</th>
                        <th>{{$t('evaluations.diplomas')}}</th>
                        <th v-if="!isStudent" class="table__cell--icon"></th>
                        <th class="table__cell--icon"></th>
                    </tr>
                </thead>
                <tbody >
                    <tr v-if="loadingStudents" :key="'loading'" class="table--loading">
                        <td colspan="4">
                            <div class="spinner"></div>
                            <div class="text-center loading_text">{{$t('evaluations.table.loading')}}</div>
                        </td>
                    </tr>
                    <tr v-if="!loadingStudents && !evaluationStudents.length" :key="'no-students'" class="table--empty">
                        <td colspan="4">
                            <div class="text-center">{{$t('evaluations.no_students')}}</div>
                        </td>
                    </tr>
                    <tr v-for="(student, index) in evaluationStudents" :key="`${student.id}_${index}`">
                        <td>{{ student.first_name }}</td>
                        <td>{{ student.last_name }}</td>
                        <td>{{ student.diplomas.map(diploma => diploma.title).join(", ") }}</td>
                        <td v-if="!isStudent"><span @click="showDiplomasModal(student)" v-tooltip.right="$t('evaluations.view_chart')" class="table__icon--clickable icons icon-chart"></span></td>
                        <td><span @click="navigateToStudent(student)" v-tooltip.right="$t('evaluations.view_evaluations')" class="table__icon--clickable icons icon-eye"></span></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <diplomas-modal />
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Watch } from 'vue-property-decorator';
    import { GET_EVALUATION_STUDENTS } from '@/store/modules/evaluation-students';
    import DiplomasModal from '@/components/modals/evaluations/DiplomasModal';
    const comparify = text => (text || '').replace(/[^a-zA-Z]/g, '').toLowerCase();

     @Component({})
    export default class EvaluationStudentsTable extends Vue {
        name = 'evaluation-students-table';
        nameFilter = null;
        mounted() {
            this.nameFilter = '';
        }

        get evaluationStudents() {
            return this.$store.state.evaluation_students.evaluationStudents;
        }

        get loadingStudents() {
            return this.$store.state.evaluation_students.loading;
        }

        get isStudent() {
            try {
                if (this.$store.state.auth.loading) return true;
                return !!(this.$store.state.auth.profile.account_types.filter(accountType => accountType.code === 'student')).length;
            } catch (error) {
                return false;
            }
        }

        @Watch('nameFilter', { })
        filterByName(name) {
            this.$store.dispatch(GET_EVALUATION_STUDENTS, { params: { q: name, page: 1 }});
        }

        navigateToStudent(student) {
            this.$router.push({ name: 'evaluations', params: { id: student.id }});
        }

        showDiplomasModal(student) {
            this.$modal.show('diplomas-modal', { student });
        }
     }
</script>



// WEBPACK FOOTER //
// src/components/tables/evaluation-students/EvaluationStudentsTable.vue